var map = {
	"./SpinGeneral_001.webp": 5560,
	"./SpinGeneral_002.webp": 3068,
	"./SpinGeneral_003.webp": 795,
	"./SpinGeneral_004.webp": 7018,
	"./SpinGeneral_005.webp": 8744,
	"./SpinGeneral_006.webp": 5579,
	"./SpinGeneral_007.webp": 9097,
	"./SpinGeneral_008.webp": 6013,
	"./SpinGeneral_009.webp": 4486,
	"./SpinGeneral_010.webp": 7788,
	"./SpinGeneral_011.webp": 949,
	"./SpinGeneral_012.webp": 2233,
	"./SpinGeneral_013.webp": 4769,
	"./SpinGeneral_014.webp": 7729,
	"./SpinGeneral_015.webp": 3862,
	"./SpinGeneral_016.webp": 6944,
	"./SpinGeneral_017.webp": 3831,
	"./SpinGeneral_018.webp": 1813,
	"./SpinGeneral_019.webp": 2602,
	"./SpinGeneral_020.webp": 5089,
	"./SpinGeneral_021.webp": 2900,
	"./SpinGeneral_022.webp": 6162,
	"./SpinGeneral_023.webp": 2217,
	"./SpinGeneral_024.webp": 8546,
	"./SpinGeneral_025.webp": 4040,
	"./SpinGeneral_026.webp": 8894,
	"./SpinGeneral_027.webp": 4424,
	"./SpinGeneral_028.webp": 1016,
	"./SpinGeneral_029.webp": 7540,
	"./SpinGeneral_030.webp": 8245,
	"./SpinGeneral_031.webp": 4054,
	"./SpinGeneral_032.webp": 8176,
	"./SpinGeneral_033.webp": 2302,
	"./SpinGeneral_034.webp": 19,
	"./SpinGeneral_035.webp": 9935,
	"./SpinGeneral_036.webp": 8489,
	"./SpinGeneral_037.webp": 1140,
	"./SpinGeneral_038.webp": 4542,
	"./SpinGeneral_039.webp": 3380,
	"./SpinGeneral_040.webp": 2939,
	"./SpinGeneral_041.webp": 402,
	"./SpinGeneral_042.webp": 9077,
	"./SpinGeneral_043.webp": 7345,
	"./SpinGeneral_044.webp": 4888,
	"./SpinGeneral_045.webp": 8143,
	"./SpinGeneral_046.webp": 2683,
	"./SpinGeneral_047.webp": 7063,
	"./SpinGeneral_048.webp": 4237,
	"./SpinGeneral_049.webp": 6809,
	"./SpinGeneral_050.webp": 6946,
	"./SpinGeneral_051.webp": 6203,
	"./SpinGeneral_052.webp": 4933,
	"./SpinGeneral_053.webp": 2972,
	"./SpinGeneral_054.webp": 704,
	"./SpinGeneral_055.webp": 4217,
	"./SpinGeneral_056.webp": 8434,
	"./SpinGeneral_057.webp": 1165,
	"./SpinGeneral_058.webp": 2046,
	"./SpinGeneral_059.webp": 7564,
	"./SpinGeneral_060.webp": 2765,
	"./SpinGeneral_061.webp": 3583,
	"./SpinGeneral_062.webp": 8624,
	"./SpinGeneral_063.webp": 9420,
	"./SpinGeneral_064.webp": 8095,
	"./SpinGeneral_065.webp": 2292,
	"./SpinGeneral_066.webp": 1113,
	"./SpinGeneral_067.webp": 1688,
	"./SpinGeneral_068.webp": 3449,
	"./SpinGeneral_069.webp": 813,
	"./SpinGeneral_070.webp": 9228,
	"./SpinGeneral_071.webp": 5186,
	"./SpinGeneral_072.webp": 7533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 515;